import MsViewerProfileBg from './MsViewerProfileBg';

export default function MsViewerProfile() {
    return <MsViewerProfileBg />;
}
